import { r as registerInstance, h } from './index-5faac9d7.js';
import { b as productCtas, a4 as CAASContentOverviewSlotName } from './currency-49e0d692.js';
import { r as requestRangeSelectorConfig } from './helper-baea569d.js';
import { u as updateProductCtasSelectorSettings } from './product-selector-utils-df1f9eca.js';
import { T as TAB_NAMES } from './constants-74678075.js';
import { a as getFilteredBreadcrumbs } from './utils-1b416b6b.js';
import './index-39f51a91.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';
import './analytics-74fe4f64.js';
import './number-fcf5283d.js';
import './navigation-83d2f79a.js';
import './constants-7d3b1dc0.js';

const ProductAppRange = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productCtasState = this.productCtas;
    this.productSelector = null;
    this.requestRangeSelectorConfigCreator = () => requestRangeSelectorConfig(this.host, this.rangeId);
    this.host = undefined;
    this.endpoint = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.rangeId = undefined;
    this.showBreadcrumbs = undefined;
    this.showDocuments = undefined;
    this.productCtas = productCtas;
    this.showBuyOnline = undefined;
    this.siteType = undefined;
    this.mainInfo = undefined;
    this.tabs = undefined;
    this.recentlyViewedProducts = undefined;
    this.isTabsInitialized = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.documentListing = undefined;
  }
  productCtasDidChange(newProductCtas) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.productSelector, this.productCtas.buttons);
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs((_a = this.mainInfo) === null || _a === void 0 ? void 0 : _a.breadcrumbs);
  }
  getRichText(content) {
    const { richText } = content;
    const richTextResponse = richText || content.MainContent[0].richText;
    return richTextResponse === null || richTextResponse === void 0 ? void 0 : richTextResponse.map((item) => item.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim());
  }
  render() {
    const { image, name, description, masterRangeName, longDescription, rangePartofLabel, } = this.mainInfo;
    return (h("se-container", { display: "block", style: {
        'background-color': '#FFF',
      } }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: false, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs" })), h("pes-range-main", { host: this.host, endpoint: this.endpoint, rangePartofLabel: rangePartofLabel, commercialStatus: this.mainInfo.commercialStatus, description: description, image: image, longDescription: longDescription, masterRangeName: masterRangeName, name: name, brandLogo: this.mainInfo.brandLogo, id: this.mainInfo.id, localeCode: `${this.countryCode.toUpperCase()}/${this.languageCode}`, rangeCtas: this.mainInfo.rangeCtas, requestRangeSelectorConfig: this.requestRangeSelectorConfigCreator, rangeType: this.mainInfo.rangeType }), this.tabs.tabs && (h("pes-range-tabs", { tabs: this.tabs.tabs, appProductsLabel: this.mainInfo.appProductsLabel, commonFiltersFilterBy: this.mainInfo.commonFiltersFilterBy, facetButtonResetAllLabel: this.mainInfo.facetButtonResetAllLabel, facetButtonViewLessFilters: this.mainInfo.facetButtonViewLessFilters, facetButtonViewMoreFilters: this.mainInfo.facetButtonViewMoreFilters, nextLabel: this.mainInfo.nextLabel, pageLabel: this.tabs.pageLabel, noResultsClearLink: this.mainInfo.noResultsClearLink, noResultsHeader: this.mainInfo.noResultsHeader, noResultsMessage: this.mainInfo.noResultsMessage, numberProductsOfAllProductsLabel: this.mainInfo.numberProductsOfAllProductsLabel, previousLabel: this.mainInfo.previousLabel, rangeProductLabel: this.mainInfo.rangeProductLabel, rangeProductsFiltersLabel: this.mainInfo.rangeProductsFiltersLabel, viewLessLabel: this.mainInfo.viewLessLabel, viewMoreLabel: this.mainInfo.viewMoreLabel, viewProductsLabel: this.mainInfo.viewProductsLabel, rangePresentationLabel: this.mainInfo.rangePresentationLabel, loadMoreLabel: this.tabs.loadMoreLabel, loadPreviousLabel: this.tabs.loadPreviousLabel, backLabel: this.mainInfo.backLabel, localeCode: `/${this.countryCode}/${this.languageCode}`, rangeReference: this.mainInfo.rangeReference, host: this.host, endpoint: this.endpoint, rangeSoftwareAndFirmwareLabel: this.mainInfo.rangeSoftwareAndFirmwareLabel, descriptionBigger: this.mainInfo.descriptionBigger, id: this.mainInfo.id, name: name, navigationState: this.mainInfo.navigationState, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, seoURl: this.seoUrl, productCtas: this.productCtasState, isPBS: true, nodes: this.mainInfo.nodes, documentListing: this.documentListing }, h("slot", { slot: CAASContentOverviewSlotName, name: CAASContentOverviewSlotName }))), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { isBackgroundGrey: true, class: "pes-app-range__section" }))));
  }
  static get watchers() { return {
    "productCtas": ["productCtasDidChange"]
  }; }
};

export { ProductAppRange as pes_app_range };
